import { string } from 'yup';

const rule = {
	name: 'emailRequireDomainSuffix',
	method ({ message } = { message: 'Please enter a valid email address.' }) {

		const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/;
		return this.test('emailRequireDomainSuffix', message, function (value) {

			const { path, createError } = this;
			return value.length < 1 || regex.test(value.trim()) || createError({ path, message });

		});

	},
	schemaType: string
};

export default rule;
